<style>
    .ly-total-amount {
        border:1px solid #dfe6ec;
        border-top: 0;
        text-align: right;
        color: #48576a;
        font-size: 12px;
        padding: 8px 50px;
    }
</style>
<template>
    <div class="p20">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="12">
                <h1 style="padding-top:5px;">新建收款账户</h1>
            </el-col>
            <el-col :span="12" class="tr">
                <el-button type="primary" @click="submit" size="small" :loading="submitLoad">
                    <i class="fa fa-save" v-if="!submitLoad"></i>&nbsp;提交
                </el-button>
                <ly-router-button size="small">
                    <i class="fa fa-chevron-left"></i>&nbsp;返回
                </ly-router-button>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <!-- 表单列表 start -->
        <el-card class="box-card mt15">
            <Ly-search-form 
                :config="formConfig" 
                :rules="formRules"
                :is-search="false"
                label-width="120px"
                ref="searchForm">
            </Ly-search-form>
        </el-card>
        <!-- 表单列表 end -->
    </div>
</template>
<script>
    /**
     * 客户回款，银行登记单 新增
     * @time 2017-10-25
     * @author zjs
     */
    import AddFormConfig from './add-form'
    import AddRulesConfig from './rules'
    import LySearchForm from '@c/search-form'
    import LyRouterButton from '@c/router-button'

    import {mapGetters} from 'vuex'
    export default {
        mixins: [
            AddFormConfig, 
            AddRulesConfig
        ],
        components: {
            LySearchForm,
            LyRouterButton
        },
        computed: {
            ...mapGetters([
                'userInfo'     
            ])
        },
        data () {
            return {
                num1: "",
                submitLoad: false, // 提交按钮的状态标识
                submitForm: {
                    uuid: ''
                } // 提交的表单数据
            }
        },
        mounted () {
            // 设置UUID
            this.submitForm.uuid = this.$utils.createUUID()
            // 初始设置制作单人
            this.initData()
        },
        watch: {
            userInfo () {
                this.initData()
            },
            '$route' (to, from) {
                // 清空之前的输入
                if (to.name === 'BankAccountAdd') {
                    this.$refs['searchForm'].resetForm()
                    // 初始化数据
                    this.initData()
                }
            }
        },
        methods: {
            /**
             * 初始化的数据设置
             */
            initData () {
                // 初始设置制作单人、收胎人
                this.$refs['searchForm'].initBindFormData({
                    submiter: this.userInfo.name
                })
            },
            submit () {
                if (this.$refs['searchForm'].validateForm()) {
                    this.submitLoad = true
                    // 获得得查询的字段
                    this.submitForm = Object.assign(this.submitForm, this.$refs['searchForm'].bindForm)
                    // 提交数据
                    this.$api.create('api/bankaccount',this.submitForm).then((rs) => {
                            this.$alert('数据提交成功', '新增', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    this.submitLoad = false
                                    // 跳转到详情页面
                                    this.$router.push('/bill/bankaccount/info/' + rs.id)
                                }
                            });
                            // 更新UUID
                            this.submitForm.uuid = this.$utils.createUUID()
                    }).catch((error) => {
                            this.submitLoad = false
                            this.$message({
                                message: error,
                                type: 'warning'
                            })
                    })
                } else {
                    this.$message({
                        message: '请将信息填写完整',
                        type: 'warning'
                    })
                }
            }
        }
    }
</script>